import { get } from '@stencil/megatron';
import { OUR_PROMISES_AND_USER_STORIES_URL } from '@stencil/flights-constants/src/urls';
import sendToClientAnalytics from '@stencil/client-side-analytics/src/send-to-client-analytics-server';
import getCommonHeaders from '@stencil/flights-utils/src/get-common-headers';

// const pushToNewRelic = (newRelicObj: object) => {
//   sendToClientAnalytics({
//     apiName: 'minfare_api',
//     serviceApp: 'aerial_seo',
//     ...newRelicObj
//   });
// };

export const getOurPromisesAndUserStories = async (flavour = '') => {
  const response = await get(OUR_PROMISES_AND_USER_STORIES_URL, {
    name: 'Our Promises And User Stories API',
    headers: { 'x-pfm': flavour, currency: 'inr', locale: 'en-IN', ...getCommonHeaders() }
  });
  if (!response || !response.data) {
    return {};
  }
  return response.data;
};

export const getPreSearchData = async (
  url: string,
  flavour: string,
  queryType: string,
  locale: string = 'en-IN'
) => {
  try {
    const res = await get(url, {
      name: 'Pre search Banner details API',
      headers: { 'x-pfm': flavour, currency: 'inr', locale, ...getCommonHeaders() }
    });
    if (!res?.data) {
      return null;
    }
    return res.data;
  } catch (error_msg) {
    // pushToNewRelic({
    //   apiName: 'thor_preSearch_api',
    //   serviceApp: 'aerial_mweb_lite',
    //   error_msg,
    //   url,
    //   flavour,
    //   queryType
    // });
    return null;
  }
};
